export enum ApiUrl {
  MIS_UPLOAD = "/mis/upload",
  MIS_UPDATE_TRANSACTIONS = "/mis/updateTransactions",
  MIS_SETTLE = "/mis/settle",
  WORKFLOW = "/settlement/workflow",
  AUTH_LOGIN = "/protocol/openid-connect/token",
  MIS_PROCESS = "/mis/process",
  CLEARING = "/mis/clearing"
}
